/*@ngInject*/
const DeleteCollaborationEmailRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.deleteCollaborationEmail = function (emailId) {
        let url = '/rest/Email/' + emailId;

        return this.delete(url);
    };
};

angular.module('gw-um-submission')
    .service('deleteCollaborationEmailRepository', DeleteCollaborationEmailRepository);
